<div class="row">
  <div class="col-4">
    <button
      *ngIf="observationsEdit"
      type="button"
      class="btn btn-lg btn-block"
      [class]="!newObservation ? 'btn-success' : 'btn-danger'"
      (click)="newObservation = !newObservation; selectedObservation = null"
    >
      {{
        !newObservation ? ("observations.create-new" | translate) : ("general.cancel" | translate)
      }}
    </button>
    <ul
      class="list-group my-2"
      *ngIf="observations?.length > 0"
      style="max-height: 200px; overflow-x: auto"
    >
      <li
        class="list-group-item d-flex justify-content-between c-pointer"
        [class]="selectedObservation?.id == item.id ? 'active' : ''"
        (click)="selectedObservation = item; newObservation = false"
        *ngFor="let item of observations"
      >
        <p class="m-0">{{ item.title }}</p>
        <i
          class="fa fa-check-circle"
          [class]="selectedObservation?.id == item.id ? 'text-light' : 'text-success'"
          *ngIf="item.solved"
          aria-hidden="true"
        ></i>
      </li>
    </ul>
  </div>
  <div class="col-8" [class]="selectedObservation || newObservation ? '' : 'center'">
    <p class="m-0" *ngIf="!selectedObservation && !newObservation">
      {{ "observations.select" | translate }}
    </p>
    <ng-container *ngIf="newObservation">
      <h4>{{ "observations.create-new" | translate }}</h4>
      <form [formGroup]="observationForm">
        <div class="form-group">
          <label for="title">{{ "tables.title" | translate }}*</label>
          <input
            type="title"
            name="title"
            formControlName="title"
            class="form-control"
            id="title"
            placeholder="Error en sensor de.."
          />
        </div>
        <div class="form-group">
          <label for="description">{{ "tables.description" | translate }}</label>
          <textarea
            class="form-control"
            name="description"
            formControlName="description"
            id="description"
            rows="3"
          ></textarea>
        </div>
        <div class="float-right">
          <button
            type="submit"
            class="btn btn-success"
            [disabled]="observationForm.invalid"
            (click)="createObservation()"
          >
            {{ "observations.add" | translate }}
          </button>
        </div>
      </form>
    </ng-container>
    <ng-container *ngIf="selectedObservation">
      <div class="d-flex flex-column align-items-start">
        <div class="d-flex w-100 justify-content-between mb-2">
          <div class="left">
            <p class="mb-0">
              {{ "tables.title" | translate }}:
              <b>{{ selectedObservation.title }}</b>
            </p>
            <p class="mb-0">{{ selectedObservation.author.username }}</p>
          </div>
          <div class="right text-right">
            <p class="mb-0">
              {{ "tables.creation-date" | translate }}:
              <b>{{ selectedObservation.created | date : "medium" }}</b>
            </p>
            <span
              class="badge"
              [class]="selectedObservation.solved ? 'badge-success' : 'badge-warning'"
              >{{ selectedObservation.solved ? "Solucionado" : "Sin solucionar" }}</span
            >
          </div>
        </div>
        <p>{{ selectedObservation.description }}</p>

        <div
          class="mt-5 d-flex justify-content-end w-100"
          *ngIf="!selectedObservation.solved && observationsEdit"
        >
          <button class="btn btn-primary" (click)="solveObservation()">
            {{ "observations.solved" | translate }}
            <i class="fa fa-check" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</div>
